module.exports = __webpack_public_path__ + "img/Hypoxia-OVCA_10X_WTA.65ec1710.png";